import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import TableContainer from '@material-ui/core/TableContainer';
import GlobalUrl from "./../../Global";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
} from "@material-ui/core";

import DoneAllIcon from '@material-ui/icons/Done';
import EventIcon from '@material-ui/icons/Event';
import Tooltip from "@material-ui/core/Tooltip";
import _ from "lodash";
import Colors from "./../../Global/colors";
import moment from "moment";
import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner2";
import NoRecords from "./../../Global/NoRecords";
import EditG from "../../Assets/edit.png";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
//import luxon from "luxon";
//import { DateTime } from "luxon";
//Redux
import { useSelector } from "react-redux";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  container: {
    maxHeight: "55vh",  
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));

export default function ScheduleManager({
  state,
  setState,
  scheduleLoader,
  searchText,
  handleScroll,
  groups,
}) {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const history = useHistory();
  const [mybtn, setbtn] = useState(false);
  const [permissionList, setpermissionList] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentCompany, setCurrentCompany] = React.useState({});
  const [user, setUser] = useState({});
  const [packageDetails, setPackageDetails] = React.useState(null);

  async function getPackageDetails(company) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  let company = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      setCurrentCompany(company);
      fetchUser(company);
      fetchAllUser(company);
      permission();
      getPackageDetails(company);
    },
    [company?.id]
  );

  function handlePackage(e) {
    history.push(e);
  }

  const permission = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      user_id: data.user_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalUrl + "/Permission/get_user_permissions?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        //  alert(response.data)

        //console.log(response.data)
        setpermissionList(response.data);
        result(response.data);
      })
      .catch((error) => console.log(error));
  };

  const result = (data) => {
    let permlist = [];

    data.map((value, index) => {
      permlist.push(value.Permission.title);
    });
    console.log(permlist);

    if (permlist.indexOf("Schedule Management") !== -1) {
      setbtn(false);
    }
    if (permlist.indexOf("Admin") !== -1) {
      setbtn(false);
    } else {
      setbtn(true);
    }
  };



  const fetchUser = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      user_id: data.user_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          setUser(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUser();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const fetchAllUser = (company) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          setUsers(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchAllUser(company);
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const handleTemplateSearch = (e) => {
    var data = e;
    console.log(e);
    if (data == "cleared") {
      const Status = state.Schedule.filter(
        (Status) => "Active" === Status.Status
      );

      // const All = state.Schedule;

      setState({
        ...state,
        filter_arr: Status,
      });
    } else {
      const Listing = state.Schedule.filter((sch) => e === sch.template_id);
      setState({
        ...state,
        filter_arr: Listing,
      });
    }
  };

  const assignee = (e) => {
    var data = e;
    console.log(data);
    if (data == "cleared") {
      const Status = state.Schedule.filter(
        (Status) => "Active" === Status.Status
      );

      setState({
        ...state,
        filter_arr: Status,
      });
    } else {
      // const Listing = state.Schedule.filter((Assignee) => {
      //   return Assignee.ScheduleAssignees.filter((b, i) => {
      //     console.log(b.user_id == data, b.user_id, data, i);
      //     return b.user_id == data;
      //   });
      // });
      const Listing = _.filter(state.Schedule, {
        ScheduleAssignees: [{ user_id: e }],
      });

      console.log(Listing);
      setState({
        ...state,
        filter_arr: Listing,
      });
    }
  };

  const selected = ({ Active, Finished, Paused }) => {
    const Status = state.Schedule.filter(
      (Status) =>
        Active === Status.Status ||
        Finished === Status.Status ||
        Paused === Status.Status
    );
    setState({
      ...state,
      filter_arr: Status,
    });
  };

  // const filter = state.filter_arr != null ? state.filter_arr : state.Schedule;

  const list =
    state.Schedule.length !== 0 ? (
      state.Schedule.filter(
        (v) =>
          v?.title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          v?.template_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          v?.site_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          user?.first_name?.toLowerCase().includes(searchText?.toLowerCase())||
          user?.last_name?.toLowerCase().includes(searchText?.toLowerCase())
      ).map((response, index) => {
       
        let _groups = JSON.parse(response?.group_ids) || [];

        _groups = groups.filter(item => _groups.includes(item.id))

        response.groupArr = _groups;

        console.log(response, "response")
        return (
          <TableRow
            //class="pointer-cursor"
            className="pointer-cursor"
          >
            <TableCell
              style={{
                padding: 10,
                textAlign: language === "ar" ? "right" : "left",
                textTransform: "capitalize",
              }}
            >
              {
                <Tooltip title={response?.title ? response?.title : ""}>
                  <p style={{ margin: 0 }}>
                    {response?.title.slice(0, 30) +
                      (response?.title.length > 30 ? "..." : "")}
                  </p>
                </Tooltip>
              }
            </TableCell>
            <TableCell
              style={{
                padding: 10,
                borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        textAlign: language === "ar" ? "right" : "left",
                textTransform: "capitalize",
              }}
            >
              {
                <Tooltip
                  title={
                    response?.template_title ? response?.template_title : ""
                  }
                >
                  <p style={{ margin: 0 }}>
                    {response?.template_title?.slice(0, 20) +
                      (response?.template_title?.length > 20 ? "..." : "")}
                  </p>
                </Tooltip>
              }
            </TableCell>

            <TableCell
              style={{
                padding: 10,
                textAlign: language === "ar" ? "right" : "left",
                textTransform: "capitalize",
              }}
            >
              {
                <Tooltip
                  title={response?.site_title ? response?.site_title : ""}
                >
                  <p style={{ margin: 0 }}>
                    {response?.site_title.slice(0, 15) +
                      (response?.site_title.length > 15 ? "..." : "")}
                  </p>
                </Tooltip>
              }
            </TableCell>
            <TableCell
              style={{
                padding: 10,
                borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                textTransform: "capitalize",
                textAlign: language === "ar" ? "right" : "left",
              }}
            >
             
              {`${user.first_name} ${user.last_name}`}
            </TableCell>
            <TableCell
              className="mb-v"
              style={{
                paddingTop: "3px",
                paddingBottom: "3px",
                textAlign: language === "ar" ? "right" : "left",
                textTransform: "capitalize",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                {response?.assignees_user?.map((v, i) => {
                 if (i <= 2) {
                    return (
                      <Tooltip
                        title={`${v ? v.first_name : ""} ${
                          v ? v.last_name : ""
                        }`}
                        aria-label=""
                      >
                        {v.avatar !== null ? (
                          <div
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "50px",
                              color: "#043077",
                              display: "flex",
                              justifyContent: "center",
                              margin: 1,
                              alignItems: "center",
                              backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                v.avatar
                              })`,
                              backgroundSize: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "50px",
                              border: "1px solid #043077",
                              color: "#043077",
                              display: "flex",
                              justifyContent: "center",
                              margin: 1,
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              {v
                                ? v.first_name
                                    .substring(0, 1)
                                    .toUpperCase()
                                    .concat(
                                      v
                                        ? v.last_name
                                            .substring(0, 1)
                                            .toUpperCase()
                                        : ""
                                    )
                                : ""}
                            </p>
                          </div>
                        )}
                      </Tooltip>
                    );
                  } else {
                    return (
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50px",
                          border: "1px solid #043077",
                          color: "#043077",
                          display: "flex",
                          justifyContent: "center",
                          margin: 1,
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "10px",
                          }}
                        >
                          +{response.assignees_user.length - 3}
                        </p>
                      </div>
                    );
                  }
                })}

{response?.groupArr?.map((v, i) => {
                 if (i <= 1) {
                    return <Tooltip title={`${v ? v.group_name : ""} `} aria-label="">
                        <div style={{ width: 30, height: 30, borderRadius: "50px", border: "1px solid #043077", color: "#043077", display: "flex", justifyContent: "center", margin: 1, alignItems: "center" }}>
                          <p style={{ margin: 0, fontWeight: "bold", fontSize: "10px" }}>
                            {v.group_name
                              .substring(0, 1)
                              .toUpperCase()}
                          </p>
                        </div>
                      </Tooltip>;
                  } else {
                    return (
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50px",
                          border: "1px solid #043077",
                          color: "#043077",
                          display: "flex",
                          justifyContent: "center",
                          margin: 1,
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "10px",
                          }}
                        >
                          +{response.groupArr.length - 2}
                        </p>
                      </div>
                    );
                  }
                })}


                
              </div>
            </TableCell>
            <TableCell
              style={{
                padding: 10,
                borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                textTransform: "capitalize",
              }}
            >
              <div
                style={{
                  color: response.status == "active" ? "green" : "red",
                  // color: "#fff",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                {response.status}
              </div>
            </TableCell>
            <TableCell style={{ padding: 10,borderRight:language =="ar" ? "none" : "1px solid #dadada",
                        borderLeft:language =="ar" ? "1px solid #dadada" :  "none", }}>
              {moment(response.start_date).format("MM/DD/YY")}
            </TableCell>
            <TableCell style={{ padding: 10,textAlign:'center' }}>
            <img src={EditG} alt="edit"   onClick={() => history.push("/schedule-edit/" + response.id)} />
            </TableCell>
          </TableRow>
        );
      })
    ) : (
      <TableRow style={{ border: "1px solid #dadada" }}>
        <TableCell colSpan={8}>
          <NoRecords />
        </TableCell>
      </TableRow>
    );

  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  if (packageDetails !== null) {
    console.log(packageDetails);
    return (
      <div style={{ padding:window.innerWidth > 500 ? "10px" : "5px" }}>
        <main>
          {scheduleLoader && (
            <div
              style={{
                height: "50vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner />
            </div>
          )}

          {!scheduleLoader && (
            <div>
             {window.innerWidth > 500 && <TableContainer className={classes.container}>
     
              <Table stickyHeader aria-label="sticky table" style={{ minWidth: 500, borderLeft:'1px solid #dadada', borderRight:'1px solid #dadada' }} className="scheduleTable">
                <TableHead
                  className=""
                  style={{ backgroundColor:"#f2f2f2", color: Colors.globalColor8, borderTop:'1px solid #dadada' }}
                >
                  <TableRow>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign:language == "ar" ? "right" :"left",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Schedule")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Template")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Site")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Assigned by")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Assignees / Groups")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                        borderTop:'1px solid #dadada'
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        
                        {t("Status")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign:language == "ar" ? "right" :"left",
                        borderTop:'1px solid #dadada',
                        borderRight:language =="ar" ? "none" : "1px solid #dadada",
                        borderLeft:language =="ar" ? "1px solid #dadada" :  "none",
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        {t("Start Date")}
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        padding: 8,
                        textAlign: language == "ar" ? "right" :"left",
                        borderTop:'1px solid #dadada',
                        
                      }}
                    >
                      <p
                        className="label2"
                        style={{
                          marginTop: 0,
                          color: Colors.globalColor8,
                          fontWeight: "bold",
                          fontSize: 12,
                          textTransform: "uppercase",
                        }}
                      >
                        {t("Edit")}
                      </p>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>{list}</TableBody>
              </Table>
            </TableContainer>}

            {window.innerWidth <= 500 && 
            <div className={classes.container} style={{overflowY:'scroll',width:'100%', padding:'5px'}}>
    {state.Schedule.length !== 0 ? (
      state.Schedule.filter(
        (v) =>
          v?.title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          v?.template_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          v?.site_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
          user?.first_name?.toLowerCase().includes(searchText?.toLowerCase())||
          user?.last_name?.toLowerCase().includes(searchText?.toLowerCase())
      ).map((response, index) => {
        return (  


          <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: "left", height: "220px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
          <div style={{display: "flex", height:"100%", flexDirection: "column", justifyContent: "space-between" }}>
            <div>
              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                Schedule
              </p>

              <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
              {response?.title.slice(0, 30) +
                      (response?.title.length > 30 ? "..." : "")}
              </p>
            </div>
            <div>
              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                Template
              </p>
              <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
              {response?.template_title?.slice(0, 20) +
                      (response?.template_title?.length > 20 ? "..." : "")}
              </p>
            </div>
            <div>
              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                Site
              </p>
              <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
              {response?.site_title.slice(0, 15) +
                      (response?.site_title.length > 15 ? "..." : "")}
              </p>
            </div>
            <div>
              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                Assigned to
              </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
               {response?.assignees_user?.map((v, i) => {
                  if (i <= 2) {
                    return (
                      <Tooltip
                        title={`${v ? v.first_name : ""} ${
                          v ? v.last_name : ""
                        }`}
                        aria-label=""
                      >
                        {v.avatar !== null ? (
                          <div
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "50px",
                              color: "#043077",
                              display: "flex",
                              justifyContent: "center",
                              margin: 1,
                              alignItems: "center",
                              backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                v.avatar
                              })`,
                              backgroundSize: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: "50px",
                              border: "1px solid #043077",
                              color: "#043077",
                              display: "flex",
                              justifyContent: "center",
                              margin: 1,
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                fontWeight: "bold",
                                fontSize: "10px",
                              }}
                            >
                              {v
                                ? v.first_name
                                    .substring(0, 1)
                                    .toUpperCase()
                                    .concat(
                                      v
                                        ? v.last_name
                                            .substring(0, 1)
                                            .toUpperCase()
                                        : ""
                                    )
                                : ""}
                            </p>
                          </div>
                        )}
                      </Tooltip>
                    );
                  } else {
                    return (
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50px",
                          border: "1px solid #043077",
                          color: "#043077",
                          display: "flex",
                          justifyContent: "center",
                          margin: 1,
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "10px",
                          }}
                        >
                          +{response.assignees_user.length - 3}
                        </p>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>

          <div style={{display: "flex", height:"100%", flexDirection: "column", justifyContent: "space-between" }}>
           <div>
           <Tooltip title={moment(response.start_date).format("DD MMM, YYYY")}>
                    <p
                      style={{ margin: 0 }}
                    >
                     <EventIcon style={{color:Colors.globalColor8}}/>
                    </p>
                  </Tooltip>
          </div>

          {response.status == "active" && <div>
           <DoneAllIcon  style={{color:'green'}}/>
          </div>}

          <div>
          <img src={EditG} alt="edit"   onClick={() => history.push("/schedule-edit/" + response.id)} />
          </div>

          </div>
        </div>
        );
      })
    ) : (
      <div style={{width:'100%'}}>
          <NoRecords />
          </div>
    )}
            </div>}
            </div>
          )}
        </main>
      </div>
    );
  } else {
    return (
      <div
        style={{
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }
}
